import React from 'react';

export const LazySiteEntryManagementPage = React.lazy(() => import('./SiteEntryManagement'));
export const LazySafetyTrainingListsPage = React.lazy(() => import('./SafetyTrainingList'));
export const LazySafetyTrainingSettingPage = React.lazy(() => import('./SafetyTrainingSetting'));
export const LazySiteEntryHistoryPage = React.lazy(() => import('./SiteEntryHistoryList'));
